import React from "react";
import { SquaredTile } from "./SquaredTile";
import { TileData } from "./HorizontalTile";

interface SquaredTilesSectionProps {
  tiles: TileData[];
  onLearnMore: (tileData: TileData) => void;
}

const getTileBackgroundColor = (index: number) => {
  // Pattern: 1st: #F6F6F6, 2nd/3rd: #E7E1D1, 4th/5th: #F6F6F6, 6th/7th: #E7E1D1, repeat...
  const pattern = [
    "#E7E1D1", // 0
    "#F6F6F6", // 1
    "#F6F6F6", // 2
    "#E7E1D1", // 3
    "#E7E1D1", // 4
    "#F6F6F6", // 5
    "#F6F6F6", // 6
  ];
  return pattern[index % pattern.length];
};

export const SquaredTilesSection: React.FC<SquaredTilesSectionProps> = ({ tiles, onLearnMore }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-y-[20px] sm:gap-y-[24px] lg:gap-y-[32px] 
    gap-x-[16px] sm:gap-x-[20px] lg:gap-x-[24px] mx-[12px] sm:mx-[16px] md:mx-[24px] lg:mx-[32px] justify-items-center h-auto pb-10">
      {tiles.map((tile, index) => (
        <SquaredTile
          key={"feature-tile-" + index}
          title={tile.title}
          text={tile.text}
          image={tile.image}
          imageStyle={tile.imageStyle}
          onLearnMore={onLearnMore}
          fullText={tile.fullText}
          actionButton={tile.actionButton}
          backgroundColor={getTileBackgroundColor(index)}
        />
      ))}
    </div>
  );
};
